const tables = document.querySelectorAll('.col-text figure.table');

if (tables.length) {
    let textContent = 'Scroll horizontaal om alles te zien';
    const textContentElement = document.querySelector('[data-table-scroll-text]');
    if (textContentElement) {
        textContent = textContentElement.dataset.tableScrollText;
    }

    tables.forEach((table) => {
        const textElement = document.createElement('div');
        textElement.textContent = textContent;
        textElement.classList.add('table-scroll-text');

        table.append(textElement);
    });
}
